/** Returns a password strength score from 0 (weakest) to 4 (strongest). */
export function passwordStrength(pw: string): number {
  let score = 0
  if (pw.length >= 15) score++
  if (/[A-Z]/.test(pw)) score++
  if (/[0-9]/.test(pw)) score++
  if (/[^A-Za-z0-9]/.test(pw)) score++
  return score
}
